import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios } from '../../../lib/axios';

// Utils
import { dataResponse, handleError } from '../../../utils';

export const apiPostVehiculo = async params => {
  const url = typesEndpoint.postCrearVehiculo;

  const request = {
    placa: params.placa,
    marca: params?.marca,
    modelo: params?.modelo,
    anio: params?.anio,
    carroceria: params?.carroceria,
    clase: params.clase,
    propietario: params.propietario,
  };

  try {
    const { status, data } = await axios.post(url, request, buildRequest());
    return dataResponse({ data: data.data, statusCode: status });
  } catch (error) {
    return handleError(error);
  }
};
